module.exports = __webpack_public_path__ + "static/media/slovenie.54371e6f.jpg";